import {putAll, showBeError, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, select, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {simpleTableSelector, getRequestedTableCsvExportParams} from 'utils/tables';

import {animalBrowserAction, GetBreedingFemalesForPrintAction} from '../action';

const tableId = 'cowBrowser';

function* execute({payload}: GetBreedingFemalesForPrintAction): SagaIterator {
    const tableState = opt(yield* select(simpleTableSelector.tableState(tableId)))
        .orCrash('no tableState');

    const {fieldParams} = getRequestedTableCsvExportParams(tableState);

    yield* put(animalBrowserAction.startPrint());
    const response = yield* call(
        Api.getBreedingFemalesEarTags,
        fieldParams.filters || [],
        {stableId: payload},
    );
    if (response.isSuccess) {
        yield* put(animalBrowserAction.setFemalesForExport(response.data.breedingFemalesEarTags || []));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('exportCows')));
    }
    yield* put(animalBrowserAction.printFinished());
}

/**
 * Loads breeding-female tags for the print/export modal.
 *
 * @returns The saga watcher for `GET_BREEDING_FEMALES_FOR_PRINT`.
 */
export function* getBreedingFemalesForPrint(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_BREEDING_FEMALES_FOR_PRINT', execute);
}
